import React, { useEffect, useState } from "react";
import {
  BackButton,
  CancelButton,
  CreateButton,
  DownloadButton,
  EditButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useLocation, useParams } from "react-router-dom";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import SideModal from "../../../../Components/Others/SideModel";
import { NormalHeading } from "../../../../Components/Utils/Heading";
import PdfLinkCq from "./Pdf/PdfLinkCq";
import NuDate from "../../../../Components/Utils/NuDate";
import ViewPdf from "./ViewPdf";
import Comments from "./CommentsPr";
import axiosInstance from "../../../../Services/axiosCommon";
import NuAmount from "../../../../Components/Utils/NuAmount";
import CommonComments from "../../../../Components/Utils/commonComments";
import ApprovalComponent from "../../../../Components/Utils/approvalComponent";
import { Tab, Tabs } from "../../../../Layouts/MainPage/Tabs";
import CQPdfOthers from "../../ViewPdfTemplate/CQPdfOthers";
import FilesView from "../../../../Components/Utils/FilesView";
import PDFViewWithAPI from "../../../../Components/Utils/PDFViewWithAPI";
import PDFViewer from "../../../../Components/Utils/PDFViewer";
import {
  GetAccess,
  GetMultiNotUseRole,
  GetRole,
} from "../../../../Components/Utils/roles";
import QuoteComparisonModal from "../../../../Components/Utils/QuoteComparisonModal";
import { GetCurrentSymbol } from "../../../../Components/Utils/OtherFuction";

import { useQuery } from "@tanstack/react-query";
import { formatDisplaySno } from "../../../../Components/Utils/formatDisplaySno";

const ViewCustomerQuotes = () => {
  const { quotesViewId } = useParams();
  const location = useLocation();

  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  const [data, setData] = useState(null);
  const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
  const [showPdfComponent, setShowPdfComponent] = useState(false);
  const [showQuoteComparison, setShowQuoteComparison] = useState(false);
  const EditAccess = "customer_quote_edit";

  // Fetch Customer Quotation Details using React Query
  const { data: fetchedCqData, refetch: refetchCq } = useQuery({
    queryKey: ["CQ-details", quotesViewId],
    queryFn: async () => {
      const res = await axiosInstance.get(`/customer-quotations/${quotesViewId}`);
      return res.data?.data || null;
    },
    enabled: !!quotesViewId,
    refetchOnMount: "always",
    staleTime: 0,
  });

  useEffect(() => {
    if (fetchedCqData) {
      setData(fetchedCqData);
    }
  }, [fetchedCqData]);
  const [pdfLoading, setPdfLoading] = useState(false);
  const handlePdfIconClick = async () => {
    setShowPdfComponent(true);
    if (!viewPDF) {
      setPdfLoading(true);
      await ViewPDF();
      setPdfLoading(false);
    }
  };

  const id = quotesViewId;
  const getUrl = `/customer-quotations/get-status`;
  const putUrl = `/customer-quotations/edit-status`;
  const statusUrl = "/customer-quotations/all-status";

  const [revData, setRevData] = useState([]);

  useEffect(() => {
    if (quotesViewId) getRevData(quotesViewId);
  }, [quotesViewId]);

  function getRevData(id) {
    axiosInstance
      .get(`/customer-quotations/products-lists/${id}`)
      .then((res) => {
        console.log("ree", res?.data?.data);
        if (res?.data?.data) {
          const formattedData = res.data.data.map((item) => ({
            ...item,
            revProduct: formatDisplaySno(item.revProduct || []),
          }));
          setRevData(formattedData);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [filePathList, setFilePathList] = useState([]);
  const [filePathListSQ, setFilePathListSQ] = useState([]);

  useEffect(() => {
    if (
      data?.rfqAttachments !== null &&
      data?.rfqAttachments !== "None" &&
      data?.rfqAttachments !== "[]"
    ) {
      setFilePathList(
        data?.rfqAttachments?.length > 0 ? data?.rfqAttachments : [],
      );
      // console.log('image',createNew?.rfqAttachments);
      // setRemoveFilePathList(data?.productImage);
      // console.log('images',filePathList);
    }
  }, [data]);

  const downloadPDF = async () => {
    try {
      const response = await axiosInstance.get(
        `/customer-quotations/download-pdf/${quotesViewId}`,
        {
          responseType: "blob", // Important to specify the response type as blob
        },
      );

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      // Create a link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(pdfBlob);
      link.download = `${data?.ref}.pdf`; // The filename you want for the downloaded file

      // Append the link to the body (required for Firefox)
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  const [viewPDF, setViewPDF] = useState(null);

  const ViewPDF = async () => {
    try {
      const response = await axiosInstance.get(
        `/customer-quotations/download-pdf/${quotesViewId}`,
        {
          responseType: "blob", // Important to specify the response type as blob
        },
      );

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      // Create a link element
      let Viewlink = window.URL.createObjectURL(pdfBlob);
      setViewPDF(Viewlink);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  // Removed automatic PDF fetch on load - fetch only when user clicks PDF preview

  const [sumOfTotal, setSumOfTotal] = useState("");

  useEffect(() => {
    let tempPrice = 0;
    revData[0]?.revProduct.forEach((i) => {
      let price = (Number(i?.price) || 0) * (Number(i?.quantity) || 0);
      tempPrice += price;
    });
    setSumOfTotal(tempPrice);
  }, [revData[0]?.revProduct]);

  return (
    <div className="w-full h-full py-2 px-2 lg:px-4 ">
      <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb
            items={[
              {
                name: "Customer Quotation",
                link: "/sales/quotes",
              },
              {
                name: "View Customer Quotation",
              },
            ]}
          />
          <div className="flex md:hidden items-center gap-2">
            <Link
              to={"/sales/quotes"}
              state={{
                currentPage: pageIndex,
                searchQuery: searchQuery != "" ? searchQuery : "",
              }}
            >
              <BackButton link={true} />
            </Link>
            <DownloadButton
              handleClick={downloadPDF}
              label="Download as PDF"
            />
            {(data?.editable === false ? GetRole() : GetAccess(EditAccess)) && (
              <Link
                to={`/sales/quotes/edit/${quotesViewId}`}
                state={{
                  data: data,
                  from: `/sales/quotes/view/${quotesViewId}`,
                  pageIndex: pageIndex,
                  searchQuery: searchQuery,
                }}
              >
                <EditButton height="8" />
              </Link>
            )}
          </div>
        </div>

        <div className="hidden md:flex items-center gap-2">
          <Link
            to={"/sales/quotes"}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link>
          <DownloadButton
            handleClick={downloadPDF}
            label="Download as PDF"
          />
          {(data?.editable === false ? GetRole() : GetAccess(EditAccess)) && (
            <Link
              to={`/sales/quotes/edit/${quotesViewId}`}
              state={{
                data: data,
                from: `/sales/quotes/view/${quotesViewId}`,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
            >
              <EditButton height="8" />
            </Link>
          )}
        </div>
      </div>

      <div className="w-full mx-auto lg:h-[calc(100vh-125px)] overflow-y-auto rounded-md p-2 flex flex-col lg:flex-row gap-3 text-[#111537]">
        <div className="w-full lg:w-[70%] bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden flex flex-col">
          <div className="w-[98%] bg-white px-2 mx-auto border border-gray py-2 rounded-lg flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 z-10">
            <div className="grid items-center w-full sm:w-[80%]">
              <div className="flex text-[14px] mb-1 text-[#111537] font-semibold items-center flex-wrap gap-2">
                <p className="break-words">{data?.ref}</p>
                {data?.isRevised === true && (
                  <div>
                    <span className="inline-block rounded-full bg-yellow-100 px-3 py-1 text-xs font-semibold text-yellow-800 shadow">
                      🔁 Revised
                    </span>
                  </div>
                )}
              </div>
              <div className="flex flex-wrap gap-x-4 gap-y-1">
                <p className="text-xs text-[#111537]">
                  Date :{" "}
                  {data?.createdAt ? (
                    <NuDate
                      value={data?.createdAt}
                      format="DD-MMM-YYYY, hh:mm A"
                    />
                  ) : (
                    "N/A"
                  )}
                </p>
                <p className="text-xs text-[#111537]">
                  Created By : {data?.preparedByName || "None"}
                </p>
              </div>
            </div>

            <div className="flex sm:flex-col justify-between sm:justify-end w-full sm:w-[20%] items-center sm:items-end">
              <div className="flex justify-end">
                <div className="border rounded-md border-[#579BB1] text-xs inline-flex w-auto flex-shrink-0 justify-end">
                  <p className="bg-white text-black p-1 rounded-l-md">
                    Status{" "}
                  </p>
                  <p className="bg-[#579BB1] text-white p-1 items-center rounded-r-md">
                    {data?.status || "None"}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full flex-1 overflow-y-auto p-2 pb-8">
            <div className="w-full flex flex-wrap px-2 border border-gary mt-2 rounded-lg mb-2">
              <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 py-1">
                <div className="w-full flex px-2 items-center">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                    Sales Person
                  </p>
                  <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                    : {data?.salesPerson || "-"}
                  </p>
                </div>
                <div className="w-full flex px-2 items-center">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                    Validity
                  </p>
                  <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                    : {data?.validity || "-"}
                  </p>
                </div>
                <div className="w-full flex px-2 items-center">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                    Availability
                  </p>
                  <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                    : {data?.availability || "-"}
                  </p>
                </div>

                <div className="w-full flex px-2 items-center">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                    Del. Terms
                  </p>
                  <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                    : {data?.deliveryTerms || "-"}
                  </p>
                </div>
                <div className="w-full flex px-2 items-center">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                    Pmt. Terms
                  </p>
                  <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                    : {data?.paymentTerms || "-"}
                  </p>
                </div>

                <div className="w-full flex px-2 items-center">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                    RFQ Assign.
                  </p>
                  <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                    :{" "}
                    {(data?.rfqAssignees &&
                      data?.rfqAssignees.map((item, index) => {
                        return (
                          <span key={index}>
                            {item}
                            {index !== data?.rfqAssignees.length - 1 ? "," : ""}
                          </span>
                        );
                      })) ||
                      "Not Assigned"}
                  </p>
                </div>
                {data?.isEmailSent === true && (
                  <div className="w-full flex px-2 items-center">
                    <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                      Email Sent Date & Time
                    </p>
                    <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                      :{" "}
                      {data?.emailSentDateTime ? (
                        <NuDate
                          value={data?.emailSentDateTime}
                          format="DD-MMM-YYYY, hh:mm A"
                        />
                      ) : (
                        "N/A"
                      )}
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="flex gap-4 mt-4">
              <div className="w-full">
                <p className="text-xs font-medium text-[#111537] p-1">
                  YPR Description
                </p>
                <div className="border border-gary h-16 overflow-y-scroll rounded-lg items-center">
                  <p className="text-xs p-2 break-words text-[#606279]">
                    {data?.prDesc || "-"}
                  </p>
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row mt-4 gap-4">
              <div className="w-full sm:w-1/2">
                <p className="text-xs font-medium text-[#111537] p-1">
                  Special Notes
                </p>
                <div className="border border-gary h-28 overflow-y-scroll rounded-lg items-center">
                  <p className="text-xs p-2 break-words text-[#606279]">
                    {data?.specialNotes || "-"}
                  </p>
                </div>
              </div>
              <div className="w-full sm:w-1/2">
                <p className="p-1 text-xs font-medium text-[#111537]">
                  Supplier Quote Attachments
                </p>
                <div className="border border-gary overflow-y-scroll h-28 rounded-lg p-2">
                  <div className="w-full flex gap-2 items-center flex-wrap mt-1">
                    {data?.rfqAttachments &&
                      filePathList.map((imgs, idx) => {
                        return <FilesView fileView={imgs} key={idx} />;
                      })}
                  </div>
                </div>
              </div>
            </div>

            {GetMultiNotUseRole(["sales", "sales man"]) && (
              <div className="w-full flex justify-end my-1">
                <span
                  className="rounded-md py-1 px-2 text-baseColor-primary bg-slate-300 text-xs cursor-pointer"
                  onClick={() => {
                    setShowQuoteComparison(true);
                  }}
                >
                  View Quotes
                </span>
              </div>
            )}

            <div className="w-full bg-white border border-gary mt-4 rounded-lg overflow-x-auto">
              <div className="w-full min-w-[650px]">
                <div className="w-full py-2 bg-baseColor-primary flex justify-between rounded-t-lg px-2">
                  <p className="w-[5%] text-left text-white text-xs font-medium">
                    S.N.
                  </p>
                  <p className="w-[35%] text-left text-white text-xs font-medium">
                    Product
                  </p>
                  <p className="w-[5%] text-center text-white text-xs font-medium">
                    Unit
                  </p>
                  <p className="w-[10%] text-center text-white text-xs font-medium">
                    Qty
                  </p>
                  <p className="w-[15%] text-center text-white text-xs font-medium">
                    Lead Time
                  </p>
                  <p className="w-[15%] text-center text-white text-xs font-medium">
                    Price
                  </p>
                  <p className="w-[15%] text-center text-white text-xs font-medium">
                    Total
                  </p>
                </div>
                {revData[0]?.revProduct &&
                  formatDisplaySno(revData[0]?.revProduct || [])?.map((List, index) => (
                    <div
                      key={index}
                      className="w-full py-2 flex px-2 justify-between odd:bg-white even:bg-slate-100"
                    >
                      <p className="w-[5%] text-left text-xs font-medium text-[#111537]">
                        {List?.display_sno || List?.sno || index + 1}
                      </p>
                      <div className="w-[35%]">
                        <p
                          className={`text-left text-xs font-medium text-[#111537]${List?.isAlternate === true ? " text-red-500" : ""
                            }`}
                        >
                          {List?.product_name || "-"}
                        </p>

                        {List?.isAlternate === true && (
                          <p className="text-left text-[10px] font-light text-red-500">
                            (Alternate)
                          </p>
                        )}
                        {List?.notes && (
                          <div className="relative group">
                            <p className="text-left text-red-500 text-xs truncate break-words">
                              Notes : {List?.notes}
                            </p>
                            <div className="absolute hidden group-hover:block bg-gray-100 text-[#111537] text-[11.5px] font-light rounded-md px-1 py-1 w-max max-w-xs z-10">
                              {List?.notes}
                            </div>
                          </div>
                        )}
                      </div>
                      <p className="w-[5%] text-center text-xs font-medium text-[#111537]">
                        {List?.product_unit || List?.unit || "-"}
                      </p>
                      <p className="w-[10%] text-center text-xs font-medium text-[#111537]">
                        {List?.quantity || 0}
                      </p>
                      <p className="w-[15%] text-center text-xs font-medium text-[#111537]">
                        {List?.leadTime || "-"}
                      </p>
                      <p className="w-[15%] text-center text-xs font-medium text-[#111537]">
                        <NuAmount
                          currency={GetCurrentSymbol(data?.currency)}
                          value={List?.price || List?.costPrice || 0}
                        />
                      </p>
                      <p className="w-[15%] text-center  text-xs font-medium text-[#111537]">
                        <NuAmount
                          currency={GetCurrentSymbol(data?.currency)}
                          value={
                            List?.totalAmount ||
                            (Number(List?.price) || 0) * (Number(List?.quantity) || 0)
                          }
                        />
                      </p>
                    </div>
                  ))}
                <div className="w-full flex px-4 justify-end">
                  <p className="py-2 text-xs font-medium text-[#111537]">
                    Total Price{" "}
                  </p>
                  <p className=" py-2 text-xs font-medium ">
                    : <NuAmount value={sumOfTotal || data?.totalPrice || "-"} />
                  </p>
                </div>
              </div>
              {/* </>} active={index==0} key={index} >
  {item?.revName}
</Tab>
  ))
}
</Tabs> */}
              {/* <div className="w-full flex justify-end px-2 py-2">
          <div className="w-1/4 flex">
            <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
              Total Price :
            </p>
            <p className="w-1/2 py-2 text-xs font-medium ">
              {data?.totalPrice || "-"}
            </p>
          </div>
        </div> */}
            </div>
          </div>
        </div>
        <div className="w-full lg:w-[30%] overflow-auto bg-white rounded-lg drop-shadow-lg p-2 flex flex-col gap-3">
          <div className="w-full overflow-y-auto p-1 flex flex-col gap-3">
            <ApprovalComponent
              id={id}
              getUrl={getUrl}
              putUrl={putUrl}
              statusUrl={statusUrl}
              refSetData={setData}
              data={data}
              type={"CQ"}
              preUrlName={"customer-quotations"}
            />

            <div className="w-full grid  border border-gary mt-4  rounded-lg">
              {/* <p className="text-xs text-[#111537] font-medium">Customer Detail</p> */}
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">
                  Customer Detail
                </p>
              </div>
              <div className=" w-full px-2">
                <table className=" w-full border-collapse text-left">
                  <TempTrCom
                    label="Customer"
                    value={data?.customerName || "-"}
                  />

                  <TempTrCom
                    label="YPR"
                    value={data?.prRef || ""}
                    subValue={
                      data?.prDate ? (
                        <NuDate
                          value={data?.prDate}
                          format="DD-MMM-YYYY, hh:mm A"
                        />
                      ) : (
                        ""
                      )
                    }
                  />
                </table>
              </div>
            </div>
            <div className="w-full grid  border border-gary mt-4  rounded-lg ">
              <p className="text-xs text-white font-medium bg-baseColor-primary  p-2 rounded-t-lg">
                Documents{" "}
              </p>
              <div className=" w-full flex flex-wrap overflow-y-scroll h-16">
                <div
                  onClick={handlePdfIconClick}
                  className="cursor-pointer m-1 w-auto h-[25px] flex items-center  justify-between  rounded p-[2px] border "
                >
                  <svg
                    width="20"
                    height="20"
                    fill="#048178"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                  </svg>
                  <p className="w-auto text-[9px]">{data?.ref}</p>
                </div>
              </div>
            </div>

            <div className="w-full h-auto  flex  border border-gary mt-4 rounded-lg">
              <CommonComments
                visible={true}
                // closeModal={handleCloseCommentsModal}
                title="Comments"
                mainId={data?.prId}
                addurl={"/pr-comments/new-comment"}
                geturl={`/pr-comments/by-PR/${data?.prId}`}
              />
            </div>
          </div>
        </div>

        {showPdfComponent && (
          <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
            <div className="animate-scale-in relative w-[98%] h-[98%] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll flex flex-col">
              <button
                className="absolute top-2 right-2 text-white bg-red-600 rounded p-1 z-10"
                onClick={() => setShowPdfComponent(false)}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              {pdfLoading ? (
                <div className="w-full h-full flex flex-col items-center justify-center gap-3">
                  <div className="w-8 h-8 border-4 border-emerald-600 border-t-transparent rounded-full animate-spin"></div>
                  <p className="text-gray-600 font-medium text-sm">Loading Customer Quotation PDF preview...</p>
                </div>
              ) : (
                <PDFViewer pdfFile={viewPDF} />
              )}
            </div>
          </div>
        )}

        <QuoteComparisonModal
          isOpen={showQuoteComparison}
          prId={data?.prId}
          onClose={() => setShowQuoteComparison(false)}
        />
      </div>
    </div>
  );
};

export default ViewCustomerQuotes;
function TempTrCom({ label = "", value = "", subValue = "" }) {
  return (
    <tr className="w-full">
      <td className="w-[70px]">
        <p className="py-2 text-xs font-medium text-[#111537]">{label}</p>
      </td>
      <td className="w-[10px]">:</td>
      <td className="flex-1 py-2">
        <p className="text-xs text-[#606279] truncate text-wrap">{value}</p>
        {subValue && (
          <p className="text-xs text-[#606279] truncate text-wrap">
            {subValue}
          </p>
        )}
      </td>
    </tr>
  );
}